 /*
 *  about.js
 *  Project: Kanoogi Platform - About Page
 *
 *  Created by Chris Taylor on May 15, 2021
 *  Copyright 2021-2026 Kanoogi Inc. - All Rights Reserved.
 *
 */

 "use strict";

const kanoogi=window.kanoogi||{};									// Create one Kanoogi object to contain the whole shooting match
window.kanoogi=kanoogi;												// Store the master Kanoogi object into the global window object

import './style.css';
import './about.css';

import * as Module_utils from '../../Kanlibs/KAN_Utils.js';
import * as Module_logo3d from '../../Kanlibs/KAN_Logo3D.js';		// WebGL Kanoogi logo; silently falls back to SVG if unavailable
import { AboutStyleOptions } from './logoPresets.js';				// Shared opts bundle — same treatment is reused on /finish
import * as optionpanel from './optionpanel.js';

const utils=kanoogi.utils||new Module_utils.KAN_Utils();			// Initialize a new utils module if it doesn't exist
window.kanoogi.utils=utils;											// Store the master Kanoogi utils object into the global window object

const local=utils.RunningLocally();

if (local)															// Testing the code locally
	console.log("About webpage is running in local testing environment");

/* ---------------------------------------------------------------- */

(async()=>
	{
	utils.KanoogiTextLogo();

	// Promote the SVG Kanoogi logo to a 3D WebGL render using the shared
	// "About-style" preset: static intro (no fly-in / no click-to-spin),
	// warm lit-room lighting, idle Y/X rocking from t=0, plus the additive
	// red/blue/green point-light whip across the front face every 3-7s.
	// Full rationale lives in logoPresets.js. Falls back to the <img> if
	// WebGL or the model isn't available.
	const logoImg=document.getElementById('aboutlogo');
	if (logoImg) Module_logo3d.InitLogo3D(logoImg,AboutStyleOptions());

	await optionpanel.ValidateLogin();
	optionpanel.MenuState(true);

	document.getElementById('about_nav').classList.add("active");

	const renderPageID=document.getElementById("renderpage");
	if (renderPageID) renderPageID.style.visibility="visible";
	})();
